window.Menu = {
    opts: {
        desktopMenuBreakpoint: 1200,
        transInDuration: 500,
        transOutDuration: 200,
        menuIdPrefix: 'menu-'
    },
    menu: {},
    init: function () {

        var self = this,
            menu = this.menu,
            $win = $(window),
            didScroll = false,
            backTimer,
            clickTimer;

        menu.opts = this.opts;
        menu.lastScrollTop = 0;

        menu.body = $('body');
        menu.navbar = $('.navbar');
        menu.menuContainer = $('.menu-container');
        menu.dropDownMenus = $('.nav .dropdown-menu');
        menu.dropDownToggles = $('.nav .dropdown-toggle');
        menu.categoriesWithChildren = $('.menu-category a.has-children');
        menu.navbarHeading = $('.navbar-heading');
        menu.levelOne = $('.level-1');
        menu.levelTwo = $('.level-2');

        $('.logout').click(function () {
            var logoutRedirectUrl = $(this).data('logout-url');
            $.post("/api/LoginRegister/Logout/",
                function () {
                    window.location.href = logoutRedirectUrl;
                });
        });

        menu.inDesktopMode = function () {
            return ($win.width() >= self.opts.desktopMenuBreakpoint);
        };

        menu.inMobileMode = function () {
            return ($win.width() < self.opts.desktopMenuBreakpoint);
        };

        menu.navClicked = function () {
            return $('body').data('nav-clicked') ? true : false;
        };

        menu.registerClick = function () {
            menu.body.data('nav-clicked', true);
            clearTimeout(clickTimer);
            clickTimer = setTimeout(function () {
                menu.body.data('nav-clicked', false);
            }, 650);
        };

        menu.scrollNavToTop = function (level) {

            if (menu.currentMenu && level !== undefined) {

                var $navLevel = menu.currentMenu.parent().find('.level-' + level + ' .level-inner');
                if ($navLevel.length) {
                    $navLevel.scrollTop(0);
                }

            } else if (menu.currentMenu) {
                // Scroll all to top
                menu.currentMenu.parent().find('.level-inner').each(function () {
                    $(this).scrollTop(0);
                });
            }
        };

        menu.setScrollbarOffsets = function () {
            var scrollbarWidth = window.Helpers.getScrollBarWidth();

            // Add scrollbar width to navbar to prevent jump
            menu.navbar.find('> .menu-container').css('margin-right', scrollbarWidth);
            menu.navbar.find('> #country-navigator').css('padding-right', scrollbarWidth);
            $('.navbar-heading > span').css('margin-right', scrollbarWidth);
            $('#main').css('padding-right', scrollbarWidth);
            $('.sticky-footer__inner').css('margin-right', scrollbarWidth);
            $('.level-inner').css('padding-right', scrollbarWidth);

            if (scrollbarWidth) {
                $('.menu-close-inner').css('left', -(scrollbarWidth / 2));
                $('.menu-close-inner').css('position', 'relative');
            }
        };

        menu.removeScrollbarOffsets = function () {
            // Reset scrollbar width compensation in navbar
            if (!$('body').hasClass('site-selector-expanded')) {
                menu.navbar.find('> div').removeAttr('style'); // Remove style attributes
                $('.navbar-heading > span').removeAttr('style');
                $('#main').removeAttr('style');
                $('.sticky-footer__inner').removeAttr('style');
            }

            $('.level-inner').removeAttr('style');
            $('.menu-close-inner').removeAttr('style');
        };

        menu.setNavLevel = function (level) {

            var currentLevel = menu.getNavLevel();

            if (level !== undefined && level >= -1 && level < 3) {

                menu.menuContainer.attr('data-level', level);

                clearTimeout(backTimer);

                // Remove expanded when going back in level
                if (currentLevel > level) {
                    if (level == 1 && $('.sub-level.expanded').length) {
                        //$('.sub-level.expanded').removeClass('expanded')
                    } else if ($('.dropdown-toggle.expanded').length) {
                        $('.dropdown-toggle.expanded').removeClass('expanded');
                    }
                }

                // Show back link with delay
                if (menu.inMobileMode() && level > 0) {

                    menu.menuContainer.removeClass('show-back-link');
                    backTimer = setTimeout(function () {
                        menu.menuContainer.addClass('show-back-link');
                    }, 1.15 * menu.opts.transInDuration);

                    // Set heading
                    if (level === 2) {
                        menu.navbarHeading.find('.navbar-heading-caption').text($('.sub-level.expanded .title').text());
                    } else {
                        menu.navbarHeading.find('.navbar-heading-caption').text(menu.currentMenu.text());
                    }

                } else if (menu.inDesktopMode() && level > 1) {

                    backTimer = setTimeout(function () {
                        menu.menuContainer.addClass('show-back-link');
                    }, 1.15 * menu.opts.transInDuration)

                } else {
                    menu.menuContainer.removeClass('show-back-link');
                    //menu.navbarHeading.find('.navbar-heading-caption').text('');
                }

                // TODO: This unfortunately disables the mobile history back feature, but for now it
                // won't meddle with the back function when using .menu-open

                if (level == 0 && menu.inDesktopMode()) {
                    menu.updateUrlState('');
                } else if (level == 1) {
                    menu.updateUrlState('', menu.getActiveMenuID());
                }

            } else {
                menu.menuContainer.attr('data-level', -1);
            }
        };

        menu.getNavLevel = function () {
            return menu.menuContainer.attr('data-level') ? menu.menuContainer.attr('data-level') : -1;
        };

        // Initiate mobile trigger general behaviour
        var navbarToggle = $('.navbar-toggle');
        menu.menuContainer.click(function (event) {
            if (!$(event.target).is(navbarToggle)) {
                event.stopPropagation();
            }
        });

        $('.close-icon-link').on('click', function (e) {
            menu.registerClick();
            menu.closeAllMenus(true);
            e.preventDefault();
        });


        // Initiate hide on scroll down behaviour
        menu.navbarHeight = menu.navbar.outerHeight();

        $win.scroll(function (event) {
            didScroll = true;
        });

        $win.resize(function () {
            if (menu.inDesktopMode() && $('body').hasClass('mobile-menu-expanded')) {
                menu.closeAllMenus(true);
            } else if (menu.inMobileMode() && $('body').hasClass('desktop-menu-expanded')) {
                menu.closeAllMenus(true);
            }
        });

        setInterval(function () {
            if (didScroll && !menu.body.hasClass('menu-expanded') && !menu.body.hasClass('site-selector-expanded')) {
                window.Menu.hasScrolled();
                didScroll = false;
            } else if (menu.body.hasClass('menu-expanded') || menu.body.hasClass('site-selector-expanded')) {
                // Prevent nav-up after closing an overlay
                menu.lastScrollTop = menu.body.scrollTop();
                didScroll = false;
            }
        }, 250);


        // Initiate links that open the menu navigation
        $('.menu-open').on('click', function (e) {
            e.preventDefault();
            event.stopPropagation();

            menu.navbar.removeClass('nav-up');

            var menuId = $(this).data('menu-id');
            $('#menu-' + menuId).trigger('click');
        });


        // Mobile nav trigger
        menu.mobileMenuBtn = $('#mobile-menu-btn');
        menu.mobileMenuBtn.on('click', function (e) {

            if (menu.body.hasClass('menu-expanded')) {

                /*-----------------------------------
                    Collapse Mobile Nav
                 -----------------------------------*/

                $(document).trigger('hoya:closedMobileNav');
                menu.setNavLevel(-1);
                menu.body
                    .removeClass('menu-expanded')
                    .removeClass('mobile-menu-expanded');

                // Create close event

            } else {
                /*-----------------------------------
                    Expand Mobile Nav
                 -----------------------------------*/

                $(document).trigger('hoya:openedMobileNav');

                menu.setNavLevel(0); // Show base level
                menu.body
                    .addClass('menu-expanded')
                    .addClass('mobile-menu-expanded');

                // Create open event
            }
            return false;
        });

        $('.navbar-back-link').on('click', function (e) {

            var currentLevel = menu.getNavLevel();

            if (currentLevel >= 0) {
                menu.setNavLevel(currentLevel - 1);
            }

            e.stopPropagation();
            e.preventDefault();
        });

        // Make it possible to click on whole navbar to go back in level when level > 0
        $('.navbar-back').on('click', function () {
            if (menu.getNavLevel() > 0) {
                $('.navbar-back-link').trigger('click');
            }
        });


        // Create level data value on menu container
        menu.setNavLevel(-1);

        // History stuff
        this.initHistory();

        menu.getActiveMenuID = function () {
            var menuId = $('.dropdown-toggle.expanded').attr('id');
            menuId = menuId !== undefined ? menuId.replace(menu.opts.menuIdPrefix, '') : 0;
            return menuId;
        };
        menu.updateUrlState = function (title, menu_id, sub_menu_id) {

            menu_id = menu_id || 0;
            sub_menu_id = sub_menu_id || 0;

            var url = self.getNavHash(menu_id, sub_menu_id);

            History.pushState({
                func: 'nav_action',
                menuId: menu_id,
                subMenuId: sub_menu_id
            }, title, url);

        };


        return menu;
    },

    // Hide navbar on scroll down behaviour
    hasScrolled: function () {
        var menu = this.menu;
        //var delta = 5;
        //var st = menu.body.scrollTop();

        //if (Math.abs(menu.lastScrollTop - st) <= delta)
        //    return;

        //// If scrolled down and are past the navbar, add class .nav-up.
        //// This is necessary to never see what is "behind" the navbar.
        //if (st > menu.lastScrollTop && st > menu.navbarHeight && !menu.navbar.hasClass('nav-up')) {
        //    // Scroll Down
        //    menu.navbar.addClass('nav-up');

        //} else if (st < menu.lastScrollTop && menu.navbar.hasClass('nav-up')) {
        //    // Scroll Up
        //    if (st + $(window).height() < $(document).height()) {
        //        menu.navbar.removeClass('nav-up');
        //    }
        //}

        //menu.lastScrollTop = st;
    },

    getNavHash: function (menu_id, sub_menu_id) {
        menu_id = menu_id || 0;
        sub_menu_id = sub_menu_id || 0;

        var baseUrl = window.location.pathname;

        if (menu_id && sub_menu_id) {
            return baseUrl + '?expand=' + menu_id + '/' + sub_menu_id;
        } else if (menu_id) {
            return baseUrl + '?expand=' + menu_id;
        }

        return baseUrl;
    },

    initHistory: function () {

        var self = this;

        (function (window, undefined) {
            var
                History = window.History, // Note: We are using a capital H instead of a lower h
                State = History.getState();

            // Log Initial State
            //History.log('initial:', State.data, State.title, State.url);

            // Bind to State Change
            History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate
                // Log the State
                var State = History.getState(); // Note: We are using History.getState() instead of event.state

                //History.log('statechange:', State.data, State.title, State.url);
                State.data.func = (State.data.func == null) ? '' : State.data.func;


                switch (State.data.func) {
                    case 'nav_action':

                        var menuId = State.data.menuId || 0,
                            subMenuId = State.data.subMenuId || 0;

                        if (!self.menu.navClicked()) {


                            if (menuId && subMenuId) {

                            } else if (menuId) {
                                self.menu.setNavLevel(1);
                            } else if (self.menu.inDesktopMode()) {
                                self.menu.closeAllMenus(true);
                            } else if (self.menu.inMobileMode() && self.menu.getNavLevel() == 1) {
                                self.menu.setNavLevel(0);
                            } else if (self.menu.inMobileMode() && self.menu.getNavLevel() == 0) {
                                self.menu.closeAllMenus(true);
                            }
                        }
                        break;
                    default:
                        break;
                }

                return false;
            });

        })(window);

    }

};


/*********************************************
 * 
 *  Desktop Menu
 *  
 */
window.Menu.MegaMenu = function () {

    var menu = window.Menu.init(),
        menuTimer;

    // Clicked on level 1 links with children
    menu.categoriesWithChildren.on('click', function (e) {
        var $this = $(this);
        var subLevelId = $this.data('sub-level');

        $('.menu-category .sub-level').removeClass('expanded');
        $('#menu-sub-' + subLevelId).addClass('expanded');

        menu.registerClick();
        menu.setNavLevel(2);
        menu.scrollNavToTop(2);

        // Update URL state
        menu.updateUrlState('', menu.getActiveMenuID(), subLevelId);

        e.preventDefault();
    });

    menu.closeAllMenus = function (closeAll) {
        menu.dropDownToggles.each(function () {
            var toggle = $(this);

            if (closeAll || !toggle.is(menu.currentMenu)) {
                toggle.removeClass('expanded');
            }
        });

        if (menu.inDesktopMode()) {
            if (menu.currentMenu && !menu.currentMenu.hasClass('expanded')) {
                menu.currentMenu = null;
                menu.body.removeClass('menu-expanded');
            } else if (!closeAll) {
                menu.body.addClass('menu-expanded');
            } else {
                menu.body.removeClass('menu-expanded');
            }
        } else {
            menu.body.removeClass('menu-expanded');
        }

        menu.body
            .removeClass('desktop-menu-expanded')
            .removeClass('mobile-menu-expanded');

        menu.removeScrollbarOffsets();
        menu.setNavLevel(0); // reset levels
    };

    $('.menu-back').on('click', function (e) {

        menu.registerClick();
        menu.setNavLevel(1);

        e.preventDefault();
    });

    //menu.setMenuHeight = function () {
    //    var height = window.innerHeight;
    //    var width = window.innerWidth - 38;
    //
    //    menu.dropDownMenus.each(function () {
    //        var dropdownMenu = $(this);
    //        dropdownMenu.width(width);
    //        dropdownMenu.height(height);
    //    });
    //};
    //
    //menu.setMenuHeight();
    //
    //$(window).resize(function () {
    //    menu.setMenuHeight();
    //});

    //menu.body.on('click', function () {
    //    menu.closeAllMenus(true);
    //});

    // Bind dropdown links (level 0) -- expand mega navigation
    //
    $('.nav .dropdown').each(function () {

        var $dropDown = $(this),
            $dropDownMenu = $('.dropdown-menu', $dropDown),
            expandedTimer,
            loadMenuImages = function ($menu) {

                if (menu.inMobileMode()) {

                    // Load only main images in mobile mode
                    $('.menu-image-container .menu-image').each(function () {
                        if (!$(this).find('.img-placeholder').length) {
                            var $menuImage = $(this),
                                src = $menuImage.data('src'),
                                src = src.indexOf('?') === 0 ? '' : src,
                                alt = $menuImage.data('alt');

                            if (src) {
                                $menuImage
                                    .html('<div class="img-placeholder" style="background-image: url(' + src + ');"><img src="' + src + '" alt="' + alt + '"/></div>');
                                window.Helpers.onImagesLoaded($menuImage).then(() => {
                                    $menuImage.addClass('loaded');
                                });
                            } else {
                                // No image src
                                $menuImage.html('<div class="img-placeholder"></div>');
                            }
                        }
                    });

                } else if (menu.inDesktopMode() && !$menu.hasClass('images-loaded')) {

                    // Load all images in desktop mode
                    $('.menu-image', $menu).each(function () {
                        if (!$(this).find('.img-placeholder').length) {
                            var $menuImage = $(this),
                                src = $menuImage.data('src'),
                                src = src.indexOf('?') === 0 ? '' : src,
                                alt = $menuImage.data('alt');

                            if (src) {
                                $menuImage
                                    .html('<div class="img-placeholder" style="background-image: url(' + src + ');"><img src="' + src + '" alt="' + alt + '"/></div>');
                                window.Helpers.onImagesLoaded($menuImage).then(() => {
                                    $menuImage.addClass('loaded');
                                });
                            } else {
                                // No image src
                                $menuImage.html('<div class="img-placeholder"></div>');
                            }
                        }
                    });
                    $menu.addClass('images-loaded');

                    var equalHeight = $('.menu-equal-height');

                    // Match height for all menu items on same row
                    $('.menu-equal-height').each(function () {
                        $('.menu-equalize', $(this)).matchHeight();
                    });
                }
            },



            // Function to handle Desktop navigation
            handleDesktopNav = function ($menu) {

                var isExpanded = $('.nav .dropdown-toggle.expanded').length;

                menu.currentMenu = $menu;

                clearTimeout(expandedTimer);

                if (menu.currentMenu.hasClass('expanded')) {

                    /*----------------------------------------
                        Collapse Dropdown
                     ----------------------------------------*/

                    menu.removeScrollbarOffsets();

                    menu.currentMenu
                        .removeClass('expanded')
                        .removeClass('no-transition');
                    menu.body
                        .removeClass('menu-expanded')
                        .removeClass('desktop-menu-expanded')
                        .removeClass('menu-no-transition');

                    // Reset levels after collapsing after transition out
                    clearTimeout(menuTimer);
                    menuTimer = setTimeout(function () {
                        menu.setNavLevel(0);
                    }, menu.opts.transOutDuration);



                } else {
                    /*----------------------------------------
                         Expand Dropdown (Level 1)
                     ----------------------------------------*/

                    // Collapse previous dropdowns
                    menu.closeAllMenus(true);
                    menu.currentMenu = $menu;

                    if (isExpanded) {
                        // Dropdown is already open, add no-transition class
                        menu.currentMenu
                            .addClass('no-transition')
                            .addClass('expanded');

                    } else {
                        menu.currentMenu.addClass('expanded');
                    }

                    menu.setScrollbarOffsets();
                    menu.setNavLevel(1);
                    menu.scrollNavToTop();

                    menu.body
                        .addClass('menu-expanded')
                        .addClass('desktop-menu-expanded');

                    expandedTimer = setTimeout(function () {
                        menu.body.addClass('menu-no-transition');
                    }, menu.opts.transInDuration);
                }

                /*-----------------------------------
                    Load Menu Images
                 -----------------------------------*/
                loadMenuImages($dropDownMenu);

            },

            // Inline function to handle Mobile navigation
            handleMobileNav = function ($menu) {

                //var isExpanded = $('.nav .dropdown-toggle.expanded').length;

                menu.currentMenu = $menu;

                if (menu.currentMenu.hasClass('expanded')) {

                    /*----------------------------------------
                        Collapse Dropdown
                     ----------------------------------------*/

                    menu.currentMenu.removeClass('expanded');
                    menu.body
                        .removeClass('menu-expanded')
                        .removeClass('mobile-menu-expanded')
                        .removeClass('menu-no-transition');

                    // Reset levels after collapsing after transition out
                    clearTimeout(menuTimer);
                    menuTimer = setTimeout(function () {
                        menu.setNavLevel(0);
                    }, menu.opts.transOutDuration);

                    // Reset scrollbar width compensation in navbar
                    menu.navbar.find('> div').removeAttr('style'); // Remove style attributes

                } else {

                    /*----------------------------------------
                     Expand Dropdown (Level 1)
                     ----------------------------------------*/

                    // Collapse previous dropdowns
                    menu.closeAllMenus(true);
                    menu.currentMenu = $menu;

                    //if (isExpanded) {
                    //    // Dropdown is already open, add no-transition class
                    //    menu.currentMenu
                    //        .addClass('no-transition')
                    //        .addClass('expanded');
                    //
                    //}else {
                    menu.currentMenu.addClass('expanded');
                    //}

                    // Add scrollbar width to navbar to prevent jump
                    //menu.navbar.find('> div').css('margin-right', window.Helpers.getScrollBarWidth());

                    menu.setNavLevel(1);
                    menu.scrollNavToTop();

                    menu.body
                        .addClass('menu-expanded')
                        .addClass('mobile-menu-expanded');

                    /*-----------------------------------
                        Load Menu Images
                     -----------------------------------*/
                    loadMenuImages($dropDownMenu);
                }
            };


        /*********** Desktop Menu Toggles ************/

        $('.dropdown-toggle', $dropDown).on('click', function (e) {

            $(document).trigger('hoya:openedNav'); // Trigger event

            menu.registerClick();

            if (menu.inMobileMode()) {
                $(document).trigger('hoya:openedMobileNav'); // Trigger mobile nav event
                handleMobileNav($(this));
            } else {
                handleDesktopNav($(this));
            }

            e.preventDefault();
            return false;
        });


    });


    /*******************************************************
     *  Create listeners
     */
    $(document).bind('hoya:openedSiteSelector', function () {
        // When site selector has been opened
        menu.closeAllMenus(true);
    });
    $(document).bind('hoya:closedSiteSelector', function () {
        // When site selector has been closed
    });

    return menu;
};

$(function () {
    var mobileMenuBtn = $('#mobile-menu-btn');
    var isMobile = mobileMenuBtn.is(':visible');

    var menu;
    //if (isMobile) {
    //    menu = new window.Menu.MobileMenu();
    //} else {
    menu = new window.Menu.MegaMenu();
    //}


    // Enable ESC key
    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            if (menu.getNavLevel() == 2) {
                menu.setNavLevel(1);
            } else {
                menu.closeAllMenus(true);
            }
        }
    });

});